import { Row, Col, Collapse, Input, Form, Select, Button, DatePicker } from 'antd';
import moment from 'moment';
const inputStyle = {  };

class FormField extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { label, render } = this.props;
        return (
            <Row>
                <Col span={24}>
                    <Form.Item
                        label={label}
                        labelCol={{
                            xs: { span: 24 },
                            sm: { span: 8 }
                        }}
                        wrapperCol={{
                            xs: { span: 24 },
                            sm: { span: 16 }
                        }}
                    >
                        {render}
                    </Form.Item>
                </Col>
            </Row>
        );
    }
};

export default Form.create()(
class SearchEmail extends React.Component {
    constructor(props) { super(props); }

  componentDidMount() {
    if (this.props.role != 'admin' || this.props.endorsementId ) {
        this.handleSubmit();
    }
  }

    handleSubmit = e => {
        const { services, searchFields, form, pagination } = this.props;

        if (e) e.preventDefault();
        form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                if (values.dateSent) values = {...values, timezoneOff: moment().local().format('ZZ') };
                if(searchFields.userId) values = {...values, userIdNumber: session.jti };
                if(!(searchFields.receiveRole)) values = {...values, receiveRole: this.props.role };
                services.storeSearchValues(values)
                services.storePagination(1, pagination.pageSize);
                services.getEmailsBySearch({...values, pageSize: pagination.pageSize, pageNum: 1 });
            }
        });
    }

    generateSchoolArray = schoolArray => schoolArray && schoolArray.map(school => (
        <Select.Option key={school.id} value={school.id}>
            {school.name}
        </Select.Option>
    ));

    generateOrganizationSelect = props => (
        <Select size='small' allowClear={true} style={inputStyle}
          showSearch filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
            {this.generateSchoolArray(props.userSchools)}
        </Select>
    );

    generateMessageTypeSelect = props => (
        <Select size='small' allowClear={true} style={inputStyle}
          showSearch filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
            {this.generateMessageArray(props.messageTypes)}
        </Select>
    );

    generateReceiveRoles = () => (
        <Select size='small' allowClear={true} style={inputStyle}
          showSearch filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
            <Select.Option key='a' value='a'>{'Administrator'}</Select.Option>
            <Select.Option key='c' value='c'>{'Candidate'}</Select.Option>
            <Select.Option key='d' value='d'>{'DOD'}</Select.Option>
            <Select.Option key='f' value='f'>{'FSDO'}</Select.Option>
            <Select.Option key='p' value='p'>{'Provider'}</Select.Option>
        </Select>
    );

    generateMessageArray(messageArray) {
        let
        descriptionMap = [],
        messageReturn = [];

        messageArray.map(messagey => {
            if(!(descriptionMap[messagey.typeDescription])) {
                descriptionMap[messagey.typeDescription] = messagey.typeDescription;
                messageReturn.push(
                    <Select.Option key={messagey.typeDescription} value={messagey.typeDescription}>
                        {messagey.typeDescription}
                    </Select.Option>
                );
            }
        });

        return messageReturn;
    }

    handleReset = () => this.props.form.resetFields();

    generateSearchFields() {
        const
        leftCols = [],
        rightCols = [],
        { form, searchFields, endorsementId } = this.props,
        { getFieldDecorator } = form;

        // Left
        if(searchFields.school) leftCols.push(<FormField
            label='School:'
            render={getFieldDecorator('orgId', {})(this.generateOrganizationSelect(this.props))}
        />);

        if(searchFields.messageType) leftCols.push(<FormField
            label='Message Type:'
            render={getFieldDecorator('messageCode', {})(this.generateMessageTypeSelect(this.props))}
        />);

        if(searchFields.studentName) leftCols.push(<FormField
            label={'Student\'s Last Name/Surname:'}
            render={getFieldDecorator('studentName', {})(<Input size='small' style={inputStyle} />)}
        />);

        if(searchFields.receiveRole) leftCols.push(<FormField
            label='Roles:'
            render={getFieldDecorator('receiveRole', {})(this.generateReceiveRoles(this.props))}
        />);

        if(searchFields.trId) leftCols.push(<FormField
            label='Endorsement ID:'
            render={getFieldDecorator('endorsementId', {initialValue: endorsementId})(<Input size='small' style={inputStyle} />)}
        />);

        // Right
        if(searchFields.msgId) rightCols.push(<FormField
            label='Message ID:'
            render={getFieldDecorator('msgId', {})(<Input size='small' style={inputStyle} />)}
        />);

        if(searchFields.trId) rightCols.push(<FormField
            label='TR ID:'
            render={getFieldDecorator('trId', {})(<Input size='small' style={inputStyle} />)}
        />);

        if(searchFields.recipientName) rightCols.push(<FormField
            label={'Recipient\'s Last Name/Surname:'}
            render={getFieldDecorator('recipientName', {})(<Input size='small' style={inputStyle} />)}
        />);

        if(searchFields.dateSent) rightCols.push(<FormField
            label='Date Sent:'
            render={getFieldDecorator('dateSent', {})(<DatePicker size='small' style={inputStyle} />)}
        />);

        if(searchFields.userName) rightCols.push(<FormField
            label='Recipient User ID:'
            render={getFieldDecorator('userId', {})(<Input size='small' style={inputStyle} />)}
        />);

        return(
            <Row type='flex' justify='space-around' align='middle' gutter={15}>
                <Col span={12}>
                    {leftCols}
                </Col>
                <Col span={12}>
                    {rightCols}
                </Col>
            </Row>
        );
    }

    render() {
        const buttonStyle = { width: '120px', borderRadius: '20px' };

        return (
            <div>
                <Row type='flex' justify='center' style={{ marginBottom: '10px', marginTop: '20px' }}>
                    <Col span={23}>
                        <Collapse bordered={false} defaultActiveKey='1' style={{
                            background: '#fff',
                            borderRadius: '4px',
                            boxShadow: 'rgb(150, 150, 150) 0px 0px 20px',
                            borderStyle: 'none none solid solid',
                            borderWidth: '0px 0px 0px 5px',
                            borderColor: 'rgb(0, 68, 136)',
                            overflow: 'hidden'
                        }}>
                            <Collapse.Panel
                                key='1'
                                header={
                                    <div style={{
                                        display: 'inline-block',
                                        width: '100%',
                                        textAlign: 'center',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        fontStyle: 'italic',
                                        position: 'relative',
                                        left: '-28px'
                                    }}>
                                        {'Search Email'}
                                    </div>
                                }
                            >
                                <Form onSubmit={e => this.handleSubmit(e)}>
                                    <Row type='flex' justify='space-around' align='middle'>
                                        <Col span={23}>
                                            {this.generateSearchFields()}
                                        </Col>
                                    </Row>
                                    <Row type='flex' justify='space-around' align='middle' gutter={15} style={{ marginBottom: '10px' }}>
                                        <Col span={12} style={{ textAlign: 'right' }}>
                                            <Button
                                                size='small'
                                                type='primary'
                                                htmlType='submit'
                                                style={buttonStyle}
                                            >
                                                {'Submit'}
                                            </Button>
                                        </Col>
                                        <Col span={12} style={{ textAlign: 'left' }}>
                                            <Button
                                                size='small'
                                                type='primary'
                                                onClick={this.handleReset}
                                                style={buttonStyle}
                                            >
                                                {'Reset'}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Collapse.Panel>
                        </Collapse>
                    </Col>
                </Row>
            </div>
        );
    }
});
